import React from "react";
import Cookies from "universal-cookie";
import { Navigate, useNavigate } from "react-router-dom";

const cookies = new Cookies();

/**
 * This is special component this make sure that user only get in if he is logged in.
 * It also appends error block component to handle errors.
 * @param Component
 * @param rest
 * @returns {*}
 * @constructor
 */
export const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const token = cookies.get("user") && cookies.get("user").id;
  if (token) {
    return children
  }
  console.log(window.location.pathname,"window.location.pathname");
  return navigate(`/log-in?return_to=${window.location.pathname}`); //<Navigate to={`/log-in?return_to=${window.location.pathname}`} replace />;
};
